import { createSelector } from 'reselect'

export const selectProjectData = state => state.project?.present

export const selectVisualParamsData = createSelector(
    selectProjectData,
    state => state?.visualParams
)